import { createMuiTheme } from '@material-ui/core/styles';

export function getThemes(primaryColor, secondaryColor) {
  const styledThemeColors = {
    primary: primaryColor,
    secondary: secondaryColor,
  };

  const materialThemeGlobal = createMuiTheme({
    palette: {
      primary: {
        main: primaryColor,
      },
      secondary: {
        main: secondaryColor,
      },
    },
  });

  // const designSystemTheme = {
  //   borderRadius: {
  //     big: '16px',
  //     circle: '50%',
  //     medium: '8px',
  //     none: '0px',
  //     small: '4px',
  //     smallest: '2px',
  //   },
  //   boxShadows: {
  //     medium: '0px 4px 6px rgba(0, 0, 0, 0.16), 0px 4px 6px rgba(0, 0, 0, 0.1)',
  //     none: 'none',
  //     small: '0px 2px 4px rgba(0, 0, 0, 0.16), 0px 2px 4px rgba(0, 0, 0, 0.1)',
  //     smallest:
  //       '0px 1px 2px rgba(0, 0, 0, 0.16), 0px 1px 2px rgba(0, 0, 0, 0.1)',
  //   },
  //   palette: {
  //     actions: {
  //       border: '#757575',
  //       disabledBackground: 'E0E0E0',
  //       disabledText: '#BDBDBD',
  //       gray50: '#FAFAFA',
  //       hover: '#F5F5F5',
  //       outlinedStroke: '#BDBDBD',
  //       selected: '#EEEEEE',
  //     },
  //     error: {
  //       contrastText: '#FFFFFF',
  //       dark: '#E31B0C',
  //       darkText: '#621B16',
  //       light: '#F88078',
  //       lightBg: '#FEECEB',
  //       main: '#F44336',
  //     },
  //     info: {
  //       contrastText: '#FFFFFF',
  //       dark: '#0B79D0',
  //       darkText: '#0D3C61',
  //       light: '#64B6F7',
  //       lightBg: '#E9F5FE',
  //       main: '#2196F3',
  //     },
  //     other: {
  //       activeRating: '#FFB400',
  //       backdrop: '#808080',
  //       contrastText: '#FFFFFF',
  //       disabled: '#BDBDBD',
  //       divider: '#E0E0E0',
  //       primary: '#424242',
  //       secondary: '#757575',
  //       snackbarBackground: '#212121',
  //       tapHighlightColor: '#8fdaf1',
  //     },
  //     primary: {
  //       main: primaryColor,
  //       active: '#c2e7e3',
  //       activeContained: '#4c978e',
  //       contrastText: '#e0f3f1',
  //       dark: '#006b5d',
  //       hover: '#f0f6f6',
  //       light: '#53cbba',
  //       main: '#009a8a',
  //       outlinedStrokeBorder: '#7dcac2',
  //       selected: '#e6f2f1',
  //     },
  //     secondary: {
  //       main: secondaryColor,
  //       activeContained: '#4C5FAE',
  //       activeOutlined: '#D2D2EF',
  //       contrastText: '#e9eaf9',
  //       dark: '#001B8B',
  //       hover: '#F8F7FC',
  //       light: '#7b6fef',
  //       main: '#4443BC',
  //       outlinedStroke: '#9F9FDB',
  //       selected: '#F0F0FA',
  //     },
  //     warning: {
  //       dark: '#C77700',
  //       darkText: '#663D00',
  //       light: '#FFB547',
  //       lightBg: '#FFF5E5',
  //       main: '#FF9800',
  //     },
  //   },
  //   strokes: {
  //     big: '8px',
  //     medium: '4px',
  //     none: '0px',
  //     small: '2px',
  //     smallest: '1px',
  //   },
  //   typography: {
  //     // body1: {
  //     //   fontSize: '16px',
  //     //   fontWeight: 400,
  //     //   lineHeight: '26px',
  //     // },
  //     // body2: {
  //     //   fontSize: '14px',
  //     //   fontWeight: 400,
  //     //   lineHeight: '22px',
  //     // },
  //     // body3: {
  //     //   fontSize: '12px',
  //     //   fontWeight: 400,
  //     //   lineHeight: '17px',
  //     // },
  //     button: {
  //       fontSize: '14px',
  //       fontWeight: 500,
  //       lineHeight: '24px',
  //     },
  //     fontFamily: 'Poppins, Helvetica, Arial, sans-serif',
  //     h3: {
  //       fontSize: '20px',
  //       fontWeight: 700,
  //       lineHeight: '32px',
  //     },
  //     linkLarge: {
  //       fontSize: '16px',
  //       fontWeight: 400,
  //       lineHeight: '22px',
  //       textDecoration: 'none',
  //     },
  //     linkLargeHover: {
  //       fontSize: '16px',
  //       fontWeight: 400,
  //       lineHeight: '22px',
  //       textDecoration: 'underline',
  //     },
  //     linkMedium: {
  //       fontSize: '14px',
  //       fontWeight: 400,
  //       lineHeight: '22px',
  //       textDecoration: 'none',
  //     },
  //     linkMediumHover: {
  //       fontSize: '14px',
  //       fontWeight: 400,
  //       lineHeight: '22px',
  //       textDecoration: 'underline',
  //     },
  //     linkSmall: {
  //       fontSize: '12px',
  //       fontWeight: 500,
  //       lineHeight: '22px',
  //       textDecoration: 'none',
  //     },
  //     linkSmallHover: {
  //       fontSize: '12px',
  //       fontWeight: 500,
  //       lineHeight: '22px',
  //       textDecoration: 'underline',
  //     },
  //     // menu: {
  //     //   fontSize: '14px',
  //     //   fontWeight: 700,
  //     //   lineHeight: '22px',
  //     // },
  //     subtitle1: {
  //       fontSize: '16px',
  //       fontWeight: 500,
  //       lineHeight: '28px',
  //     },
  //     subtitle2: {
  //       fontSize: '14px',
  //       fontWeight: 500,
  //       lineHeight: '21px',
  //     },
  //     subtitleDesktop: {
  //       fontSize: '24px',
  //       fontWeight: 700,
  //       lineHeight: '32px',
  //     },
  //     subtitleMobile: {
  //       fontSize: '16px',
  //       fontWeight: 700,
  //       lineHeight: '26px',
  //     },
  //     titleDesktop: {
  //       fontSize: '34px',
  //       fontWeight: 700,
  //       lineHeight: '42px',
  //     },
  //     titleMobile: {
  //       fontSize: '20px',
  //       fontWeight: 700,
  //       lineHeight: '24px',
  //     },
  //   },
  // };

  return { styledThemeColors, materialThemeGlobal };
}
